import { Injectable } from '@angular/core';
import { Inputfiledsbase } from '../../../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../../../question-textbox';
import { TextareaQuestion } from '../../../../../question-textarea';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebComponentsNameService {
  constructor() {}

  getComponentNameform() : any{
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'name',
        label: 'Component Name',
        required: true,
        order: 1,
      }),
    ];
    return questions.sort((a, b) => a.order - b.order);
  }
}
